import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getShortlistingLogsPercentageAsync } from 'src/services/costModelling/skuShouldCostWorkbench.services'

const initialState = {
  isPollingStarted: false,
  loader: false,
  error: '',
  logs: {
    completed_count: 0,
    failed_count: 0,
    total_count: 0,
    completed_percentage: 0,
    status: null,
    isModelReviewed: false,
    trigger_method: null,
  },
}

export const ifaShortlistingPollingDataSlice = createSlice({
  name: 'ifa-shortlisting-polling-data',
  initialState,

  reducers: {
    startPolling: (state) => {
      state.isPollingStarted = true
    },

    stopPolling: (state) => {
      state.isPollingStarted = false
    },

    clearPollingData: (state) => {
      state.logs = initialState.logs
      state.error = ''
      state.loader = false
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getShortlistingLogsPercentageAsync.pending), (state) => {
      state.loader = true
      state.error = ''
    })

    builder.addMatcher(isAnyOf(getShortlistingLogsPercentageAsync.fulfilled), (state, action) => {
      state.loader = false
      state.logs = action.payload?.data || initialState.logs
      state.error = ''
    })

    builder.addMatcher(isAnyOf(getShortlistingLogsPercentageAsync.rejected), (state, action) => {
      state.loader = false
      state.error = action?.payload?.message || 'Failed to fetch shortlisting logs'
    })
  },
})

export const { startPolling, stopPolling, clearPollingData } =
  ifaShortlistingPollingDataSlice.actions

export default ifaShortlistingPollingDataSlice.reducer
